import angular from 'angular';
import uiRouter from 'angular-ui-router';

import TaxationComponent from './taxation.component';

import Closings from './closings/closings';
import Invoices from './invoices/invoices';
import Settings from './settings/settings';

const fiscalManagementModule = angular.module('tinaba.components.taxation', [
  uiRouter,
  Closings.name,
  Invoices.name,
  Settings.name
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('taxation', {
      url: '/taxation',
      template: '<taxation></taxation>',
      redirect: 'taxation.settings',
      data: {
        services: true // show services in sidenav
      }
    });
})

.component('taxation', TaxationComponent);

export default fiscalManagementModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/taxation/taxation.js
 **/